interface MuxThumbnailSettings {
  format?: string;
  width?: number;
  time?: number;
}

// Make defaults a constant
const DEFAULTS: Required<MuxThumbnailSettings> = {
  format: 'webp',
  width: 500,
  time: 0,
};

export const getMuxThumbnail = (
  muxPlaybackId: string,
  settings: MuxThumbnailSettings = {},
) => {
  const outputSettings = { ...DEFAULTS, ...settings };

  return `https://image.mux.com/${muxPlaybackId}/thumbnail.${outputSettings.format}?width=${outputSettings.width}&time=${outputSettings.time}`;
};
